module.exports = __webpack_public_path__ + "static/media/pic_phone@3x.76c3eaf4.png";